import request from '@/utils/request'

// 登录方法
export function teacherDetail (data) {
    return request({
        url: 'product/teacher/detail',
        method: 'post',
        data: data,
    })
}
